import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Sort, PageEvent, MatTableDataSource, MatSort, MatExpansionPanel, MatSnackBar } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { ClienteService } from '../../../providers/cliente.service';
import { Entidad, TipoEntidad } from '../../../interfaces/entidad';
import { PermisoService } from '../../../providers/permiso.service';
import { Direccion } from '../../../interfaces/direccion';
import { VolverService } from '../../../providers/volver.service';
import { TipoCliente } from '../tipos-cliente/tipo-cliente/tipo-cliente';
import * as moment from 'moment';
import { ZerosPipe } from '../../../pipes/transforms/zeros.pipe';
import { BooleanTraductorPipe } from '../../../pipes/transforms/boolean-traductor.pipe';
import { FormatDatePipe } from '../../../pipes/transforms/format-date.pipe';
import { Telefono } from '../../../components/telefono/telefono.component';
import { ContactoService } from '../../../providers/contacto.service';

@Component({
  selector: 'app-ver-clientes',
  templateUrl: './ver-clientes.component.html',
  styleUrls: ['./ver-clientes.component.scss']
})
export class VerClientesComponent implements OnInit {
  title = "Clientes";
  actualizarTablaTimeout: any; // prevenir muchos llamados consecutivos al webserver
  flag_primera_carga: boolean = true; // primera solicitud a traer datos
  cargandoTimeout: any;
  cargando: boolean = true; // para mostrar el progress-bar luego de un tiempo de busqueda
  tablaClientesColumnas = ['IdExtranet', 'fechaModificacion', 'razonSocial', 'CUIT'];
  clientesDataSource = new MatTableDataSource();
  @ViewChild(MatSort) matSort: MatSort;
  sort: Sort = { active: '', direction: '' };
  page: PageEvent = new PageEvent();
  getClientesSuscripcion: Subscription;
  clientesCount: number = 0;
  @Input() filtrosExternos: any = {}; // filtros que se aplican según el lugar donde se muestran las incidencias
  tieneFiltrosOrdenPaginado = false;
  // true si hay almenos un filtro activo
  panelConFiltroActivo = false;
  filtros: any = {
    generico: ''
  };
  @ViewChild('filtrosPanel') set filtrosPanel(v: MatExpansionPanel) {
    if (typeof v != 'undefined') {
      setTimeout(() => {
        this.checkPageState();
        if (this.panelConFiltroActivo) {
          v.open();
        }
      }, 0);
    }
  };
  descargandolistado: boolean = false;

  constructor(
    private clienteService: ClienteService,
    private permisoService: PermisoService,
    private contactoSv: ContactoService,
    private volverSv: VolverService,
    private snackBar: MatSnackBar,
    private zerosPipe: ZerosPipe,
    private datePipe: FormatDatePipe,
    private booleanPipe: BooleanTraductorPipe
  ) {
    // pregunta si tiene permisos (retorna true o false)
    // si los permisos aún no estan cargados se queda preguntando hasta que esten cargados
    this.permisoService.tienePermiso('CLIENTE-ACCIONES').then(tienePermiso => {
      if (tienePermiso) {
        this.tablaClientesColumnas.push('acciones');
      }
    });
  }

  ngOnInit() {
    // set valores iniciales
    if (this.volverSv.usaronBotonVolver()) {
      this.restaurarPageState();
    } else {
      this.reiniciarPageState();
    }
  }

  /**
   * Para arreglar un bug de angular usamos esta funcion para ordenar
   */
  setActiveSortProgrammatically(active, direction): void {
    let interval = setInterval(() => {
      if (this.matSort) {
        clearInterval(interval);
        if (this.sort.active != active || this.sort.direction != direction) {
          this.sort = <MatSort>{
            active: active,
            direction: direction
          };
          this.matSort.sort({
            id: active,
            start: direction,
            disableClear: true
          });
          // ugly hack!
          const activeSortHeader = this.matSort.sortables.get(active);
          if (activeSortHeader) {
            activeSortHeader['_setAnimationTransitionState']({
              fromState: direction,
              toState: 'active'
            });
          }
        }
      }
    }, 0);
  }

  sortData(sort: Sort) {
    this.sort = sort;
    this.actualizarTabla();
  }

  onPage(pageEvent: PageEvent) {
    localStorage.setItem('ver_clientes_paginado_size', pageEvent.pageSize.toString());
    this.page = pageEvent;
    this.actualizarTabla();
  }

  onFiltro() {
    this.page.pageIndex = 0;
  }

  /**
   * limpia las variables de page state
   * y luego restaura el estado al estado inicial
   */
  reiniciarPageState() {
    this.limpiarPageState();
    this.restaurarPageState();
  }

  /**
   * olvidar el estado de la página
   */
  limpiarPageState() {
    // filtros
    localStorage.setItem('ver_clientes_filtros', null);
    // paginado
    localStorage.setItem('ver_clientes_paginado', null);
    // sort
    localStorage.setItem('ver_clientes_sort', null);
  }

  /**
   * recuerda el estado de la página por si vuelven a ingresar
   * y hay que mostrarla tal cual como estaba
   */
  recordarPageState() {
    // filtros
    localStorage.setItem('ver_clientes_filtros', JSON.stringify(this.filtros));
    // paginado
    localStorage.setItem('ver_clientes_paginado', JSON.stringify(this.page));
    // sort
    localStorage.setItem('ver_clientes_sort', JSON.stringify(this.sort));
  }

  /**
   * restaudar la página al estado en que estaba
   */
  restaurarPageState() {
    // filtros
    let localFiltros = JSON.parse(localStorage.getItem('ver_clientes_filtros'));
    if (localFiltros != null) {
      this.filtros = localFiltros;
    } else {
      for (let propiedad in this.filtros) {
        this.filtros[propiedad] = '';
      }
    }
    // paginado
    let localPaginado = JSON.parse(localStorage.getItem('ver_clientes_paginado'));
    if (localPaginado != null) {
      this.page = localPaginado;
    } else {
      this.page.pageIndex = 0;
      this.page.pageSize = +localStorage.getItem('ver_clientes_paginado_size') || 10;
      this.page.length = 0;
    }
    // sort
    let localSort = JSON.parse(localStorage.getItem('ver_clientes_sort'));
    if (localSort != null) {
      // para el sort tenemos que hacerlo con un "set" porque arregla un bug de "matSort"
      this.setActiveSortProgrammatically(localSort.active, localSort.direction);
    } else {
      this.setActiveSortProgrammatically('IdCliente', 'desc');
    }
    this.actualizarTabla();
  }

  /**
   * revisa las variables de page state para ver
   * si hay almenos una aplicada ya sea filtrado, paginado u ordenamiento
   */
  checkPageState(): boolean {
    this.tieneFiltrosOrdenPaginado = false;
    // checkear si hay almenos un filtro aplicado
    this.panelConFiltroActivo = false;
    for (let propiedad in this.filtros) {
      if (this.filtros[propiedad]) {
        this.tieneFiltrosOrdenPaginado = true;
        this.panelConFiltroActivo = true;
        break;
      }
    }
    // checkear si hay paginado
    if (this.page.pageIndex != 0) {
      this.tieneFiltrosOrdenPaginado = true;
    }
    // checkear si hay ordenamiento
    if (this.sort.active != '' && (this.sort.active != 'IdCliente' || this.sort.direction != 'desc')) {
      this.tieneFiltrosOrdenPaginado = true;
    }

    return this.tieneFiltrosOrdenPaginado;
  }

  actualizarTabla(): void {
    clearTimeout(this.actualizarTablaTimeout);
    this.actualizarTablaTimeout = setTimeout(() => {
      clearTimeout(this.cargandoTimeout);
      this.cargandoTimeout = setTimeout(() => { // mostrar cargando si tarda mas de algun tiempo
        this.cargando = true;
      }, 750);

      if (this.getClientesSuscripcion && !this.getClientesSuscripcion.closed) {
        this.getClientesSuscripcion.unsubscribe();
      }

      this.recordarPageState();
      this.checkPageState();
      this.getClientesSuscripcion = this.clienteService
        .getClientes(
          {
            page: this.page.pageIndex,
            pageSize: this.page.pageSize
          },
          {
            sort: this.sort.active,
            order: this.sort.direction
          },
          Object.assign(this.filtrosExternos, this.filtros)
        )
        .subscribe(
          respuesta => {
            if (respuesta.estado == 1 && respuesta.data) {
              if (respuesta.data.total) {
                this.clientesCount = respuesta.data.total;
              }

              var clientes: Entidad[] = []; // array de datos obtenidos
              if (respuesta.data.entidades) {
                respuesta.data.entidades.forEach(entidad => {
                  if (entidad.idExtranet) {
                    clientes.push(new Entidad(
                      entidad.id,
                      entidad.razonSocial,
                      entidad.nombreFantasia,
                      entidad.nombre,
                      entidad.apellido,
                      entidad.cargo,
                      entidad.dia_nacimiento,
                      entidad.mes_nacimiento,
                      entidad.telefonoPrincipal,
                      entidad.telefonoPrincipalCodigoPais,
                      entidad.telefonoPrincipalCodigoArea,
                      entidad.telefonoPrincipalNumero,
                      entidad.telefonoMovil,
                      entidad.telefonoMovilCodigoArea,
                      entidad.telefonoMovilCodigoPais,
                      entidad.telefonoMovilNumero,
                      entidad.cuit,
                      entidad.fechaContacto,
                      <Direccion>{
                        codigoPostal: entidad.codPostal,
                        calle: entidad.direccionCalle,
                        departamento: entidad.direccionDepartamento,
                        numero: entidad.direccionNumero,
                        piso: entidad.direccionPiso,
                        localidad: entidad.localidad,
                        pais: {
                          IdPais: entidad.pais.IdPais,
                          descripcion: entidad.pais.descripcion
                        },
                        provincia: entidad.provincia
                      },
                      entidad.fechaModificacion,
                      !!+entidad.VIP,
                      <TipoEntidad>{
                        IdTipo: entidad.tipo.IdTipo,
                        descripcion: entidad.tipo.TipoDescripcion
                      },
                      entidad.idExtranet,
                      null,
                      entidad.created_by,
                      <TipoCliente>{
                        id: entidad.tipoCliente.id,
                        descripcion: entidad.tipoCliente.descripcion
                      },
                      null,
                      entidad.referencia2,
                      entidad.esCliente,
                      entidad.observacion,
                      entidad.redSocial1,
                      entidad.redSocial2,
                      entidad.paginaWeb,
                      entidad.direccionFacturacion,
                      entidad.IdTango,
                      entidad.condicionVenta,
                      entidad.porcentajeBonificacion,
                      entidad.transporte,
                      entidad.certificacion,
                      entidad.fechaCertificacion,
                      entidad.pago,
                      entidad.examen,
                      entidad.kit,
                      entidad.perfil,
                    ));
                  }
                });
              }

              this.clientesDataSource.data = clientes;
            }
          },
          () => {
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
            this.cargando = false; // ocultar progress bar si se estaba mostrando
          },
          () => {
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
            this.cargando = false; // ocultar progress bar si se estaba mostrando
          }
        );
    }, (this.flag_primera_carga ? 0 : 220));

    this.flag_primera_carga = false;
  }

  descargarListado() {
    this.descargandolistado = true;
    this.clienteService.getClientes(
      {
        page: 0,
        pageSize: this.clientesCount
      },
      {
        sort: this.sort.active,
        order: this.sort.direction
      },
      Object.assign(this.filtrosExternos, this.filtros)
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.entidades) {
          const titulos = [
            "ID EXTRANET",
            "Razón social",
            "DNI/CUIT",
            "Fecha de contacto",
            "Tipo de cliente",
            "País",
            "Provincia",
            "Localidad",
            "Código postal",
            "Calle",
            "Número",
            "Piso",
            "Departamento",
            "Fecha de modificación"
          ].join(';') + "\r\n";

          let entidadesParaExportar = [];
          const datos = respuesta.data.entidades.map((a: any) => {
            entidadesParaExportar.push(a.id);
            return [
              this.zerosPipe.transform(a.idExtranet, 7),
              a.razonSocial,
              a.cuit,
              this.datePipe.transform(a.fechaContacto, "YYYY-MM-DD HH:mm:ss", "DD/MM/YYYY HH:mm:ss"),
              a.tipoCliente.descripcion,
              a.pais.descripcion,
              a.provincia,
              a.localidad,
              a.codPostal,
              a.direccionCalle,
              a.direccionNumero,
              a.direccionPiso,
              a.direccionDepartamento,
              this.datePipe.transform(a.fechaModificacion, "YYYY-MM-DD HH:mm:ss", "DD/MM/YYYY HH:mm:ss")
            ].join(';');
          }).join("\r\n");

          const fecha = moment().format("YYYYMMDD_HHmmss");
          const csvConfig = "data:text/csv;charset=utf-8,%EF%BB%BF";
          let csvContent = titulos + datos;
          let downloadLink = document.createElement("a");
          downloadLink.href = csvConfig + encodeURI(csvContent);
          downloadLink.download = this.title + "_" + fecha + ".csv";
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);

          this.descargarListadoContactos(entidadesParaExportar, fecha);
        } else {
          this.fallaDescargarListado();
        }
      },
      () => {
        this.descargandolistado = false;
        this.fallaDescargarListado();
      },
      () => {
        this.descargandolistado = false;
      }
    );
  }

  descargarListadoContactos(entidades, fecha) {
    this.descargandolistado = true;
    this.contactoSv.getContactos(
      {
        page: 0,
        pageSize: null
      },
      {
        sort: null,
        order: null,
      },
      {
        entidadesIDs: entidades
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.contactos) {
          const titulos = [
            "Cliente",
            "Tipo de contacto",
            "Nombre",
            "Email",
            "Celular",
            "Teléfono",
            "Interno",
            "Fecha de alta"
          ].join(';') + "\r\n";

          const datos = respuesta.data.contactos.map((a: any) => {
            return [
              a.entidad.razonSocial,
              a.tipo.desc,
              a.nombre,
              a.email,
              (new Telefono(a.celular.pais, a.celular.area, a.celular.numero)).getString(),
              (new Telefono(a.telefono.pais, a.telefono.area, a.telefono.numero)).getString(),
              a.interno != null ? a.interno : '',
              this.datePipe.transform(a.fechaAlta, "YYYY-MM-DD HH:mm:ss", "DD/MM/YYYY HH:mm:ss"),
            ].join(';');
          }).join("\r\n");

          const csvConfig = "data:text/csv;charset=utf-8,%EF%BB%BF";
          let csvContent = titulos + datos;
          let downloadLink = document.createElement("a");
          downloadLink.href = csvConfig + encodeURI(csvContent);
          downloadLink.download = "Contactos" + "_" + fecha + ".csv";
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        } else {
          this.fallaDescargarListado();
        }
      },
      () => {
        this.descargandolistado = false;
        this.fallaDescargarListado();
      },
      () => {
        this.descargandolistado = false;
      }
    );
  }

  fallaDescargarListado() {
    this.snackBar.open('Lo sentimos, no se pudo descargar el listado', 'OK', { duration: 4750 });
  }

  ngOnDestroy() {
    if (this.getClientesSuscripcion && !this.getClientesSuscripcion.closed) {
      this.getClientesSuscripcion.unsubscribe();
    }
  }
}
